import { render, staticRenderFns } from "./CopyFieldValue.vue?vue&type=template&id=76840d26"
import script from "./CopyFieldValue.vue?vue&type=script&lang=js"
export * from "./CopyFieldValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports